import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormikProps } from 'formik'

import FieldLabelWrapperComponent from '../../../../../../features/components/Form/FieldLabelWrapper'
import FieldComponent from '../../../../../../components/Form/Field'

import { PLATFORMS } from '../fields'
import { platformOptions } from './fields'

const Field = FieldComponent as any

interface PlatformsFieldWrapperProps {
  formik: FormikProps<any>
}

const FieldLabelWrapper = FieldLabelWrapperComponent as any

const PlatformsFieldWrapper: React.FC<PlatformsFieldWrapperProps> = ({ formik }) => {
  const { t } = useTranslation()

  return (
    <FieldLabelWrapper
      label={t('Platforms')}
      horizontalView={true}
      helpText={t(
        'Platform determines where the fan targeted campaigns will show, either on Meta (Facebook and Instagram) and/or TikTok. You can set up Meta and TikTok campaigns in one go.'
      )}
    >
      <Field options={platformOptions} formik={formik} id={PLATFORMS} name={PLATFORMS} placeholder={t('Platform')} />
    </FieldLabelWrapper>
  )
}

export default PlatformsFieldWrapper
